const accountBlackList = [
    'f4f1b097-5175-477f-93cc-4e79b891cf4a',
    '1530d0a5-db5e-49a2-ab9d-8249e9aa640c',
];

export default function hasPermissionsToSeeMap(account: string) {
    return !accountBlackList.includes(account);
}
